export default __webpack_public_path__ + "static/best-logo-transparent-915a17f18dc5b7cee80a828b6cd26d01.png";